import { Form, Input, Radio, Space, Upload, message } from "antd";
import BoxContainer from "base/ui/components/BoxContainer";
import { observer } from "mobx-react";
// icons
import PageWrapper from "pages/Components/PageWrapper";
import { useTranslation } from "react-i18next";
import { SYSTEM_TITLE } from "utils/constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "base/routes/routes";
import { SearchForm, SearchItem } from "pages/Components/SearchBox";
import CustomSelect from "base/ui/components/CustomSelect";


import CustomButton from "base/ui/components/Button";
import { useEffect, useState } from "react";
import {
  campaignPresenter,
  campaignStore,
  commonPresenter,
  commonStore,
} from "stores/root_store";
import { CommonModel } from "services/Main/common_services";
import { useCheckPermission } from "utils/permissionHelper";
import { Download } from "base/ui/components/Icons";
import { InboxOutlined } from '@ant-design/icons';
import { RcFile } from 'antd/es/upload';
import { nanoid } from '@ant-design/pro-components';
import { useWatch } from 'antd/es/form/Form';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build';


const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });


// THÊM MỚI NỘI DUNG =========================================================================================================
// THÊM MỚI QUẢN LÝ NỘI DUNG =================================================================================================
const createAddContent = () => {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const contentId = searchParams.get("contentId");

    let pageTitle = "";

    // Nếu có id là chỉnh sửa (xem chi tiết)
    if (contentId) {
      useCheckPermission("EDIT");
      pageTitle = t("page-title.edit-content");
      document.title = t("page-title.edit-content") + " - " + SYSTEM_TITLE;
    } else {
      useCheckPermission("CREATE");
      pageTitle = t("page-title.add-content");
      document.title = t("page-title.add-content") + " - " + SYSTEM_TITLE;
    }

    const [form] = Form.useForm();

    // Công ty
    const [listCompany, setListCompany] = useState<CommonModel[]>([]);
    // Chi nhánhh
    const [listStore, setListStore] = useState<CommonModel[]>([]);
    // domain email
    const [listDomain, setListDomain] = useState<CommonModel[]>([]);
    const [listEmailType, setListEmailType] = useState<CommonModel[]>([]);
    // Danh sách email
    const [listEmail, setListEmail] = useState<CommonModel[]>([]);
    // lưu / lưu và tiếp tục
    const [isContinue, setContinue] = useState(false);
    // loading khi luu
    const [loading, setLoading] = useState(false);


    const typeEmail = useWatch('emailType', form)

    // Công ty
    const getDataCompany = async () => {
      await commonPresenter.getCompanyByAccount(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCompany(commonStore.commonRespone.data);
      }
    };
    // Chi nhánhh
    const getDataStore = async () => {
      await commonPresenter.getStoreByAccount(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListStore(commonStore.commonRespone.data);
      }
    };

    // domain email
    const getDataDomainEmail = async () => {
      await commonPresenter.getDomainEmail(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListDomain(commonStore.commonRespone.data);
      }
    };
    // list type email
    const getDataTypeEmail = async () => {
      await commonPresenter.getEmailType(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListEmailType(commonStore.commonRespone.data);
      }
    };

    const getDataDropdownEmail = async () => {
      await commonPresenter.getListEmail(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListEmail(commonStore.commonRespone.data);
      }
    };

    const emailField = useWatch('fromEmailAccountId', form)

    useEffect(() => {
      (async () => {
        getDataCompany();
        getDataStore();
        getDataTypeEmail()
        getDataDomainEmail()
        getDataDropdownEmail();

        if (contentId) {
          await campaignPresenter.getContentDetails(campaignStore, contentId);
          if (campaignStore.contentDetails.isSuccess) {
            const tempt = { ...campaignStore.contentDetails.data }
            Object.assign(tempt, {
              fileUrl: tempt.fileUrl ? [
                {
                  uid: nanoid(),
                  url: tempt.fileUrl,
                  name: tempt.fileUrl,
                  originFileObj: tempt.fileUrl,
                }
              ] : undefined
            })
            form.setFieldsValue(tempt);

          } else {
            message.error(campaignStore.contentDetails.message);
          }
        }
      })();
    }, []);


    const normFile = (e: any) => {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e?.fileList;
    };


    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t("page-title.content-manage"),
            to: ROUTES.CAMPAIGN.CONTENT_MANAGE.LINK,
          },
          {
            text: pageTitle,
          },
        ]}
        extras={
          <>
            <CustomButton
              loading={loading}
              onClick={(e) => {
                form.submit();
                setContinue(false);
              }}
              type="default"
              icon={<Download className="!fill-black" />}
            >
              {t("btn.save")}
            </CustomButton>
            <CustomButton
              loading={loading}
              onClick={() => {
                form.submit();
                setContinue(true);
              }}
              type="primary"
              icon={<Download className="!fill-white" />}
            >
              Lưu và tiếp tục
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <SearchForm
            form={form}
            layout="horizontal"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            labelAlign="right"
            onFinish={async (value) => {
              setLoading(true);

              let temptData = { ...value }
              if (contentId) {
                const clone = value?.fileUrl?.map(async (item: any) => {
                  if (!item.url?.startsWith('http')) {
                    return await getBase64(item?.originFileObj as RcFile)

                  } else {
                    return item?.originFileObj
                  }
                })
                if (value?.fileUrl) {
                  const cloneFile = await Promise.all(clone)
                  Object.assign(temptData, { fileUrl: cloneFile })
                }
              } else {
                let arrayTemp: string[] = []
                value.fileUrl?.map(async (item: any) => {
                  // const itemBase64 = await getBase64(item?.originFileObj as RcFile)
                  arrayTemp.push(await getBase64(item?.originFileObj as RcFile))
                })
                Object.assign(value, {
                  fileUrl: value.fileUrl ? await getBase64(value?.fileUrl[0]?.originFileObj as RcFile) : undefined
                })
              }

              const result = contentId
                ?
                await campaignPresenter.editContent({
                  ...temptData,
                  fileUrl: temptData?.fileUrl ? temptData.fileUrl[0] : undefined,
                  contentId: contentId,
                })
                : await campaignPresenter.createContent(value);

              setLoading(false);
              if (result.isSuccess) {
                message.success(result.message);
                if (isContinue) {
                  // Nếu đang chỉnh sửa thì không làm gì
                  if (!contentId) form.resetFields();
                } else {
                  navigate(ROUTES.CAMPAIGN.CONTENT_MANAGE.LINK);
                }
              } else {
                message.error(result.message);
              }
            }}

            initialValues={contentId ? undefined : {
              emailType: 'DefaultEmail'
            }}
          >
            <div className="col-span-2 flex flex-col gap-y-2">
              {/* Tên nội dung */}
              <SearchItem
                hidden={contentId ? false : true}
                name={"contentCode"}
                label={"Mã nội dung"}
              >
                <Input disabled readOnly />
              </SearchItem>
              {/* Tên nội dung */}
              <SearchItem
                rules={[{ required: true }]}
                name={"contentName"}
                label={"Tên nội dung"}
              >
                <Input />
              </SearchItem>
              {/* Loại Email */}
              <SearchItem
                name={"emailType"}
                label={"Loại Email"}
              >
                <Radio.Group
                  onChange={(e) => {
                    form.resetFields(['fromEmailAccountId'])
                  }}
                >
                  {listEmailType?.map(item => {
                    return (
                      <Radio key={item.key} value={item.key}>{item.value}</Radio>
                    )
                  })}
                </Radio.Group>
              </SearchItem>
              {/* Gửi từ Email */}
              {
                typeEmail === 'DefaultEmail' && (
                  <SearchItem
                    name={"fromEmailAccountId"} label={"Gửi từ Email"}>
                    <CustomSelect
                      allowClear
                      options={listEmail}
                      fieldNames={{ label: "value", value: "key" }}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.value ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    />
                  </SearchItem>
                )
              }
              {
                typeEmail === 'PersonalEmail' && (
                  <SearchItem label={"Gửi từ Email"} >
                    <Space className='!w-full'>
                      <SearchItem
                        name={"sentFrom"}>
                        <Input className='!w-[300px]' />
                      </SearchItem>
                      <SearchItem
                        name={"fromEmailAccountId"} >
                        <CustomSelect
                          allowClear
                          className='!w-[200px]'
                          options={listDomain}
                          fieldNames={{ label: "value", value: "key" }}
                          showSearch
                          filterOption={(input, option) =>
                            (option?.value ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        />
                      </SearchItem>
                    </Space>
                  </SearchItem>
                )
              }
              {/* Tên người gửi */}
              <SearchItem
                rules={[{ required: true }]}
                name={"senderName"}
                label={"Tên người gửi"}
              >
                <Input />
              </SearchItem>
              {/* Công ty */}
              <SearchItem
                rules={[{ required: true }]}
                name={"companyCode"}
                label={"Công ty"}
              >
                <CustomSelect
                  allowClear
                  options={listCompany}
                  fieldNames={{ label: "value", value: "key" }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.value ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </SearchItem>
              {/* Chi nhánh */}
              <SearchItem
                name={"saleOrg"}
                rules={[{ required: true }]}
                label={"Chi nhánh"}
              >
                <CustomSelect
                  options={listStore}
                  allowClear
                  fieldNames={{ label: "value", value: "key" }}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.value ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </SearchItem>
              {/* Tiêu đề */}
              <SearchItem
                rules={[{ required: true }]}
                name={"subject"}
                label={"Tiêu đề"}
              >
                <Input />
              </SearchItem>
              {/* Trạng thái*/}
              <SearchItem
                name={"actived"}
                initialValue={true}
                label={"Trạng thái"}
              >
                <Radio.Group>
                  <Radio value={true}>{t("search-form.active")}</Radio>
                  <Radio value={false}>{t("search-form.inactive")}</Radio>
                </Radio.Group>
              </SearchItem>

              <SearchItem label="Đính kèm">
                <SearchItem name="fileUrl" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                  <Upload.Dragger
                    maxCount={1}
                    // accept="image/jpeg,image/png,application/pdf"
                    beforeUpload={() => false}
                    customRequest={(options) => { }}
                    name="files">
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Nhấp hoặc kéo tệp vào khu vực này để tải lên</p>
                    <p className="ant-upload-hint">Hỗ trợ tải lên một lần hoặc hàng loạt.</p>
                  </Upload.Dragger>
                </SearchItem>
              </SearchItem>

              {/* Tham số cho nội dung gửi */}
              <SearchItem
                name={"param"}
                initialValue={"##FullName##"}
                label={"Tham số cho nội dung gửi"}
              >
                <Input readOnly />
              </SearchItem>
              {/* Nội dung*/}
              <SearchItem
                rules={[{ required: !!emailField, message: 'Vui lòng nhập nội dung' }]}
                name={"content"} label={"Nội dung"}>
                <CKEditor
                  // @ts-ignore
                  editor={Editor}
                  data={form.getFieldValue("content")}
                  onChange={(event, editor) => {
                    // @ts-ignore
                    const data = editor.getData();
                    form.setFieldValue("content", data);
                  }}
                />
              </SearchItem>
            </div>
          </SearchForm>
        </BoxContainer>
      </PageWrapper >
    );
  });
};

export default createAddContent;
